import React from 'react';

export default function Loader() {
  return (
    <div className="text-xl font-bold tracking-tight text-gray-500 p-9 text-center h-screen">
      Loading ...
    </div>
  );
}
